export type SignInModalView = "log-in" | "sign-up" | "code" | "verify" | "finish";
export type SignInModalNotice = "error" | "cancelled" | "refused";

export interface SignInModalState {
  open: boolean;
  view: SignInModalView;
  notice?: SignInModalNotice;
  email?: string;
  code?: string;
}

const CLOSED: SignInModalState = { open: false, view: "log-in" };

let state: SignInModalState = CLOSED;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribeSignInModal(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getSignInModalState(): SignInModalState {
  return state;
}

export function getClosedSignInModalState(): SignInModalState {
  return CLOSED;
}

export function openSignInModal(
  options: Omit<Partial<SignInModalState>, "open"> = {},
): void {
  state = { ...options, open: true, view: options.view ?? "log-in" };
  emit();
}

export function closeSignInModal(): void {
  state = CLOSED;
  emit();
}

export function readSignInParam(value: string | null): {
  view: SignInModalView;
  notice?: SignInModalNotice;
} | null {
  if (value === "finish" || value === "verify") return { view: value };
  if (value === "error" || value === "cancelled" || value === "refused") {
    return { view: "log-in", notice: value };
  }
  return null;
}
